(function () {
  'use strict';

  var STORAGE_KEY = 'oomame_privacy_notice_v2';
  var DISMISS_DAYS = 180;
  var API_TIMEOUT = 7000;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(function () {
    var banner = document.getElementById('oomame-privacy-opt-out');
    if (!banner || banner.dataset.oomamePrivacyReady === 'true') return;
    banner.dataset.oomamePrivacyReady = 'true';

    var acceptButton = banner.querySelector('[data-oomame-privacy-accept]');
    var optoutButton = banner.querySelector('[data-oomame-privacy-optout]');
    var closeButton = banner.querySelector('[data-oomame-privacy-close]');
    var errorMessage = banner.querySelector('[data-oomame-privacy-error]');
    var reopenButtons = document.querySelectorAll('[data-oomame-privacy-reopen]');

    function readStoredState() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        if (!saved || !saved.state) return null;

        if (saved.state === 'dismissed') {
          var expiresAt = Number(saved.expiresAt || 0);
          if (!expiresAt || Date.now() >= expiresAt) {
            window.localStorage.removeItem(STORAGE_KEY);
            return null;
          }
        }

        return saved;
      } catch (error) {
        return null;
      }
    }

    function remember(state, days) {
      try {
        var value = { state: state, savedAt: Date.now() };
        if (days) value.expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (error) {}
    }

    function setBusy(isBusy) {
      banner.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      acceptButton.disabled = isBusy;
      optoutButton.disabled = isBusy;
      closeButton.disabled = isBusy;
    }

    function updateBottomOffset() {
      if (banner.hidden) return;

      var bottom = 12;
      var stickyAtc = document.querySelector('.sticky-atc-panel');

      if (stickyAtc) {
        var style = window.getComputedStyle(stickyAtc);
        var rect = stickyAtc.getBoundingClientRect();
        var isVisible = style.visibility !== 'hidden' &&
          style.display !== 'none' &&
          Number(style.opacity || 1) > 0 &&
          rect.height > 0 &&
          rect.bottom > window.innerHeight - 40;

        if (isVisible) {
          bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top + 12));
        }
      }

      banner.style.setProperty(
        '--oomame-privacy-bottom',
        'calc(' + bottom + 'px + env(safe-area-inset-bottom, 0px))'
      );
    }

    function showBanner() {
      errorMessage.hidden = true;
      banner.hidden = false;
      document.body.classList.add('oomame-privacy-visible');
      window.requestAnimationFrame(updateBottomOffset);
    }

    function hideBanner() {
      banner.hidden = true;
      banner.removeAttribute('aria-busy');
      document.body.classList.remove('oomame-privacy-visible');
      setBusy(false);
    }

    function showError() {
      setBusy(false);
      errorMessage.hidden = false;
    }

    function withPrivacyApi(callback) {
      if (window.Shopify &&
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        callback(null, window.Shopify.customerPrivacy);
        return;
      }

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        callback(new Error('Customer Privacy API unavailable'));
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error ||
              !window.Shopify.customerPrivacy ||
              typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') {
            callback(error || new Error('Customer Privacy API unavailable'));
            return;
          }

          callback(null, window.Shopify.customerPrivacy);
        }
      );
    }

    function saveConsent(consent, state) {
      setBusy(true);
      errorMessage.hidden = true;

      var finished = false;
      var timeoutId = window.setTimeout(function () {
        if (finished) return;
        finished = true;
        showError();
      }, API_TIMEOUT);

      withPrivacyApi(function (error, privacyApi) {
        if (finished) return;

        if (error) {
          finished = true;
          window.clearTimeout(timeoutId);
          showError();
          return;
        }

        try {
          privacyApi.setTrackingConsent(consent, function () {
            if (finished) return;
            finished = true;
            window.clearTimeout(timeoutId);
            remember(state);
            hideBanner();
          });
        } catch (apiError) {
          finished = true;
          window.clearTimeout(timeoutId);
          showError();
        }
      });
    }

    acceptButton.addEventListener('click', function () {
      saveConsent({
        analytics: true,
        marketing: true,
        preferences: true
      }, 'accepted');
    });

    optoutButton.addEventListener('click', function () {
      saveConsent({
        analytics: false,
        marketing: false,
        preferences: true,
        sale_of_data: false
      }, 'optedout');
    });

    closeButton.addEventListener('click', function () {
      remember('dismissed', DISMISS_DAYS);
      hideBanner();
    });

    reopenButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        showBanner();
      });
    });

    window.addEventListener('resize', updateBottomOffset);
    window.addEventListener('scroll', updateBottomOffset, { passive: true });
    document.addEventListener('shopify:section:load', updateBottomOffset);

    if (!readStoredState()) {
      showBanner();
    }
  });
}());
